import { taxonomyAPI } from '@/providers/apis/taxonomy/taxonomy';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import TxCategoryPrefer from '../tx-category-prefer/tx-category-prefer';
import TxSubjectPrefer from '../tx-subject-prefer/tx-subject-prefer';
import { tenantSettingsAPI } from '@/providers/apis/tenant-settings/tenant-settings';
import axios from 'axios';

@Component({
    name: 'tx-fw-prefer',
    components: {
        'tx-category': TxCategoryPrefer,
        'tx-subject': TxSubjectPrefer,
    },
})

export default class TxFwPrefer extends Vue {

    // -----------------------------------------------------------------------------
    // properties

    @Prop()
    private selectedConfig: any;

    @Prop()
    private activeValue: any;

    private selectedFramework: any = {};

    private defaultFramework: any = {};

    private defaultCategory?: any = null;

    private submittedCategory: boolean = false;

    private classificaitonList: any = [];

    private subjectsList: any = [];

    @Prop()
    private tenantSettings: any;


    @Prop()
    private contentLoader: any;

    private get selectedCategory() {
        return this.classificaitonList.filter((item: any) => item && item.isCategory) || [];
    }

    private get selectedSubject() {
        const activeCategories = this.selectedCategory.map((item: any) => item.subjects).filter((item: any) =>  item);
        const activeSubjects =  (activeCategories
             && activeCategories.flat().filter((item: any) => item.isActive)) || [];

        activeSubjects.forEach((value: any, index: any) => {
                this.$set(value , 'isSubject', false);
            });
        return activeSubjects;
    }

    private get activeSubjectList() {
        let subjectIds: any = {};
        const activeSubjectList = this.tenantSettings.find((item: any) => item.key === 'tx_sub_prefs');
        if (activeSubjectList && activeSubjectList.value) {
            subjectIds = activeSubjectList.value;
        }
        return subjectIds;
    }

    private get tenantConfig() {
        return this.selectedConfig.tenantConfig || {};
    }

    private selectedFrameworkList(subject: any) {
        if (subject.frameworks.length === 1) {
            subject.frameworks.forEach((data: any, index: any) => {
                this.selectedFramework[subject.code] = data.standard_framework_id;
            });
        }
        const selectedSubFw = this.selectedFramework;
        let selectedList: any = [];
        if (selectedSubFw[subject.id]) {
            selectedList = subject.frameworks.filter(
                (item: any) => selectedSubFw[subject.id].indexOf(item.standard_framework_id) !== -1);
            }
        subject.count = selectedList.length;
        return selectedList;
    }

    private get activeTenantSetting() {
        return this.tenantSettings.find((item: any) => item.key === 'tx_fw_prefs');
    }


    // -----------------------------------------------------------------------------------
    // Hooks

    private created() {
        if (this.activeValue) {
            this.classificaitonList = this.activeValue;
            this.classificaitonList.forEach((value: any, index: any) => {
                this.$set(value , 'isCategory', true);
                this.onSelectCategory(value, index, 0);
            });
        } else {
            this.loadClassification();
            if (this.activeTenantSetting && this.activeTenantSetting.value) {
                Object.keys(this.activeTenantSetting.value).forEach((item) => {
                    this.$set(this.selectedFramework, item, this.activeTenantSetting.value[item].fw_ids);
                    this.$set(this.defaultFramework, item, this.activeTenantSetting.value[item].default_fw_id);
                });
            }
        }

    }

    // ---------------------------------------------------------------------------------
    // Actions
    private loadClassification() {
        this.classificaitonList = [];
        axios.all([
            tenantSettingsAPI.fetchClassifications(),
            taxonomyAPI.fetchTaxonomyClassifications(),
        ]).then(axios.spread((classificiation: any, taxonomyClassification) => {
                classificiation.map((item: any, index: any) => {
                    item.count = 0;
                    const txCode = taxonomyClassification.find((txItem: any) => item.id === txItem.id);
                    if (txCode) {
                        if (this.selectedConfig.tenantConfig && this.selectedConfig.tenantConfig.value) {
                            this.defaultCategory = this.selectedConfig.tenantConfig.value.default_classifier;
                        }
                        this.$set(item, 'isActive', true);
                    }
                    if (index === 0) {
                        this.$set(item, 'isCategory', true);
                    }
                    this.$set(item, 'isActive', item.isActive ? false : true);
                    this.$set(item, 'isCategory', item.isCategory ? false : true);
                    this.onSelectCategory(item, index);
                });
                this.classificaitonList = classificiation;
        }));
    }

    private selectedSubjectList(categoryId: any) {
        const category = this.selectedCategory.find((item: any) => item.id === categoryId);
        if (category && category.subjects) {
            return category.subjects.filter(((item: any) =>  item.isActive ));
        }
        return [];
    }

    private onChangeConfig() {
    //   this.$emit('onChangeConfig', this.parseConfig());
    }

    private onSelectCategory(category: any, index: any, categoryIndex: any= null) {
        if (!category.subjects) {
            this.fetchSubject(category);
        }
        this.$set(category, 'isCategory', category.isCategory ? false : true);
        this.$set(category, 'isActive', category.isActive ? false : true);
        if (index === 0 && categoryIndex === 0) {
            this.$set(category, 'isCategory', true);
        } else if (index && categoryIndex === null) {
            this.classificaitonList.forEach((value: any, subjectindex: any) => {
                if (index === subjectindex) {
                    this.$set(value, 'isCategory', true);
                } else {
                    this.$set(value, 'isCategory', false);
                }
            });
        }
    }

    private onSelectDefault(item: any) {
        this.defaultCategory = item.id;
    }

    private onSelectSubject(subject: any) {
        this.$set(subject, 'isActive', subject.isActive ? false : true);
        this.classificaitonList.forEach((subjectList: any) => {
            subjectList.count = 0;
            if (subjectList.subjects) {
                const subjectsList = subjectList.subjects;
                subjectsList.forEach((active: any) => {
                    if (active.isActive === true) {
                        subjectList.count = 1 + subjectList.count;
                    }
                });
            }
        });

    }

    private onSelectDefaultFW(subject: any, framework: any) {
        if (this.defaultFramework[subject.code]
            &&  this.defaultFramework[subject.code] === framework.standard_framework_id) {
            this.$set(this.defaultFramework, `${subject.code}`, null);
            return;
        }
        this.$set(this.defaultFramework, `${subject.code}`, framework.standard_framework_id);
    }

    private onSubmitConfig() {
        if (!this.tenantConfig) {
            this.$set(this.tenantConfig, 'value', this.parseConfig());
            this.$set(this.tenantConfig, 'key', 'tx_sub_prefs');
        }
        this.$emit('onChangeConfig', 'tx_fw_prefs' , this.parseConfig());
    }

    // ---------------------------------------------------------------------------------
    // Methods


    private parseConfig() {
        const config: any = {};
        const subjectList = Object.keys(this.selectedFramework);
        subjectList.forEach((item) => {
            config[item] = {};
            config[item].is_global_visible = false;
            config[item].fw_ids = this.selectedFramework[item];
            config[item].default_fw_id = this.defaultFramework[item] ? this.defaultFramework[item] : null;
        });
        return config;
    }

    private fetchSubject(item: any) {
        const categoryId = item.id;
        taxonomyAPI.fetchSubjects(categoryId).then((subject) => {
            this.$set(item, 'subjects', subject);
        });
    }

}
